import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from "@angular/router";
import { CclDrawerService, CclMessageService, CclNotifyService, CclPopupService } from "certain-common-library";
import { SharedService } from "./modules/shared/services/shared.service";
import { AccountService } from "./modules/shared/services/account.service";
import { EventService } from "./modules/shared/services/event.service";
import { CatalogService } from "./modules/shared/services/catalog.service";
import { LocalDataService } from "./modules/shared/services/local-data.service";
import { CookieService } from "ngx-cookie";
import { AttendeeSessionService } from "./modules/shared/services/attendee-session.service";
import { v4 as uuid } from "uuid";
import { Subscription } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { FlashMessagesService } from "angular2-flash-messages";
import { GainSightService } from "./modules/shared/services/gainsight.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    providers: [AccountService, EventService, CatalogService]
})
export class AppComponent implements OnInit, OnDestroy {
    title = "app";
    loaded: boolean = false;
    catalogErrorMessage: string = null;
    private initSubscription: Subscription;
    private subscription: Subscription;

    constructor(
        private router: Router,
        private popupService: CclPopupService,
        public sharedService: SharedService,
        private accountService: AccountService,
        private messageService: CclMessageService,
        private eventService: EventService,
        private catalogService: CatalogService,
        private cookieService: CookieService,
        private attendeeSessionService: AttendeeSessionService,
        public sanitizer: DomSanitizer,
        private _flashMessagesService: FlashMessagesService,
        private notifyService: CclNotifyService,
        private localDataService: LocalDataService,
        private gainsightService: GainSightService
        ) {
        this.subscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (!this.router.navigated) {
                    if (event.url.includes("(")) {
                        this.sharedService.navigateHelper(event.url.split("(")[0]);
                    }
                }
            }
        });
        this.initSubscription = this.messageService.getMessage().subscribe((message) => this.init(message));

        if (sharedService.getParameterByName("catalogUUID").length > 0) {
            sharedService.catalogUUID = sharedService.getParameterByName("catalogUUID");

            let redirectTo = sharedService.getParameterByName("redirectTo");

            if (sharedService.isEmptyString(redirectTo)) {
                redirectTo = "admin";
            }

            this.sharedService.navigateHelper(redirectTo + "/" + sharedService.catalogUUID);
        }
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.initSubscription);
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    init(message) {
        if (message.text == "initialize-app") {
            if(!this.cookieService.get("XSRF-TOKEN")) {
                let csrfToken = uuid();
                this.cookieService.put("XSRF-TOKEN", csrfToken);
            }

            this.sharedService.loginPopup = this.sharedService.getParameterByName("loginPopup");

            sessionStorage.setItem("catalogUUID", this.sharedService.catalogUUID);

            if (!this.sharedService.isEmptyString(this.sharedService.getParameterByName("error"))) {
                this.sharedService.errorStr = decodeURI(this.sharedService.getParameterByName("error"));
            }

            this.load();
        } else if (message.text == 'publish-catalog') {
            this.publishCatalog(this.sharedService.setup, true);
        } else if (message.text == 'launch-published-catalog') {
            this.launchPublishedCatalog();
        }
    }

    launchPublishedCatalog() {
        let url = document.location.protocol + "//" + document.location.hostname;
        window.open(url + "/speaker_catalog/#/attendee/" + this.sharedService.setup.uuid, "_blank");
    }

    publishCatalog(config, isPublished) {
        if (this.sharedService.publishInProgress) {
            return;
        }
        this.sharedService.publishInProgress = true;
        const pnotify = this.notifyService.getPNotify();
        let temp = pnotify.alert({
            title: "Publish Catalog",
            text: "Please confirm. Are you sure you want to " + (isPublished ? "publish" : "unpublish" ) + " the selected catalog?",
            addClass: "c-pnotify-confirm",
            hide: false,
            textTrusted: true,
            modules: {
                Confirm: {
                    confirm: true,
                    align: "flex-end",
                    buttons: [
                        {
                            text: "Ok",
                            textTrusted: false,
                            addClass: "",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                let replaceIndex = null;
                                let data = {
                                    id : config.id,
                                    uuid : config.uuid,
                                    isPublished: isPublished
                                }
                                this.catalogService.publishCatalog(data).subscribe((resp) => {
                                    this.sharedService.publishInProgress = false;
                                    this.sharedService.setup = resp["body"]["sessionCatalogSetupDTO"];
                                    this._flashMessagesService.show("Catalog published successfully.", { cssClass: "alert-success" });
                                    this.messageService.sendMessage('update-publish-button');
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                },
                                (err) => {
                                    this.sharedService.publishInProgress = false;
                                    let errorStr = "There was an error while publishing your catalog, please contact your administrator.";
                                    if (err.error != null) {
                                        errorStr = err.error.errorResponse.errors[0];
                                    }
                                    this._flashMessagesService.show(errorStr, { cssClass: "alert-danger" });
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                });
                                return true;
                            }
                        },
                        {
                            text: "Cancel",
                            textTrusted: false,
                            addClass: "unsaved-btn--secondary",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                this.sharedService.publishInProgress = false;
                                notice.close();
                                notice.fire("pnotify.cancel", { notice, value });
                                return false;
                            }
                        }
                    ]
                },
                Buttons: {
                    closer: false,
                    sticker: false
                }
            },
            stack: {
                modal: true
            }
        });
    }

    ngOnInit() {}
    async load() {
        if (this.sharedService.redirectTo == 'attendee') {
            this.catalogService.findByCatalogUUIDES(this.sharedService.catalogUUID).subscribe((resp) => {
                let temp: any = resp.body["sessionCatalogSetupDTO"];
                if (temp == null || temp.id == null) {
                    // TODO : display error that this catalog is not yet puublished.
                    this.catalogService.getLayoutConfig(this.sharedService.catalogUUID).subscribe((resp) => {
                        let layoutConfig:any = resp["body"];
                        if (layoutConfig.messages != null && !(this.sharedService.isEmptyString(layoutConfig.messages.unpublished) 
                        || this.isEmptyHTML(layoutConfig.messages.unpublished))) {
                            this.catalogErrorMessage = layoutConfig.messages.unpublished;
                        } else {
                            this.catalogErrorMessage = "<div>The catalog you are trying to access is not ready.</div>";
                        }
                        this.messageService.sendMessage("catalog_error-catalog", {text : this.catalogErrorMessage});
                    });
                } else {
                    // TODO : check for end date and display error message
                    let today = new Date().getTime();
                    if (temp.endDate != null && temp.endDate <= today) {
                        let layoutConfig = JSON.parse(temp.layoutConfig);
                        if (layoutConfig.messages != null && !(this.sharedService.isEmptyString(layoutConfig.messages.closed) 
                        || this.isEmptyHTML(layoutConfig.messages.closed))) {
                            this.catalogErrorMessage = layoutConfig.messages.closed;
                        } else {
                            this.catalogErrorMessage = "Access closed";
                        }
                        this.messageService.sendMessage("catalog_error-catalog", {text : this.catalogErrorMessage});
                    } else {
                        this.loadCatalogHelper(resp);
                    }
                }
            });
        } else if (this.sharedService.redirectTo == 'admin' || this.sharedService.redirectTo == 'preview') {
            this.catalogService.findByCatalogUUID(this.sharedService.catalogUUID).subscribe((resp) => {
                if (this.sharedService.redirectTo == 'preview') {
                    let temp = resp.body["sessionCatalogSetupDTO"];
                    if (temp.themeId == 0) {
                        let layoutConfig = JSON.parse(temp.layoutConfig);
                        this.sharedService.selectedTheme = layoutConfig.theme;
                    } else {
                        this.localDataService.getJSON("themes.json").subscribe((data) => {
                            let themes = data;
                            themes.forEach(theme => {
                                if (theme.id == temp.themeId) {
                                    this.sharedService.selectedTheme = theme;
                                }
                            });
                        });
                    }
                }
                this.loadCatalogHelper(resp);
            });
        } else {
            // TODO : display error message
        }
    }

    isEmptyHTML(str) {
        try {
            let ele = document.createElement("p");
            ele.innerHTML = str;
            console.log(jQuery(ele));
            if (ele.firstChild == null || $(ele.firstChild).is(':empty') || ele.firstChild["innerHTML"].trim().length == 0) {
                return 1;
            }
            return 0;
        } catch(err) {
            console.log(err);
            return 1;
        }
    }

    loadCatalogHelper(resp) {
        let temp: any = resp.body["sessionCatalogSetupDTO"];
        this.getSpeakerCustomFields(temp)
        this.getSessionCustomFields(temp)
        this.initializeCatalogConfigHelper(resp);
        this.sharedService.accountUUID = this.sharedService.setup.accountUUID;
        this.sharedService.eventUUID = this.sharedService.setup.eventUUID;
        sessionStorage.setItem("accountUUID", this.sharedService.accountUUID);
        sessionStorage.setItem("eventUUID", this.sharedService.eventUUID);
        this.accountService.getAccountByUUID(this.sharedService.accountUUID).subscribe((resp) => {
            this.helperMethodToLoad(resp);
        });
    }

    getSessionCustomFields(temp){
        this.catalogService
                .getCustomFieldList({
                    eventId: temp.eventId,
                    objectType: "SESSION",
                    isCustomFieldUsedInLayout: true
                })
                .subscribe((resp) => {
                    this.sharedService.sessionCustomFields = resp.body["data"];
                    if (this.sharedService.sessionCustomFields != null) {
                        let enumCustomFields = [];
                        let fileCustomFields = [];
                        this.sharedService.sessionCustomFields.forEach((cf) => {
                            if (
                                cf.questionTypeId == 4 ||
                                cf.questionTypeId == 5 ||
                                cf.questionTypeId == 6 ||
                                cf.questionTypeId == 7
                            ) {
                                enumCustomFields.push(cf);
                            } else if (cf.questionTypeId == 19) {
                                fileCustomFields.push(cf);
                            }
                        });
                        this.sharedService.sessionEnumCustomFields = enumCustomFields;
                        this.sharedService.sessionFileCustomFields = fileCustomFields;
                    }
                });
    }

    getSpeakerCustomFields(temp) {
        this.catalogService
                .getCustomFieldList({
                    eventId: temp.eventId,
                    objectType: "SPEAKER"
                })
                .subscribe((resp) => {
                    this.sharedService.speakerCustomFields = resp.body["data"];
                    if (this.sharedService.speakerCustomFields != null) {
                        let enumCustomFields = [];
                        let fileCustomFields = [];
                        this.sharedService.speakerCustomFields.forEach((cf) => {
                            if (
                                cf.questionTypeId == 4 ||
                                cf.questionTypeId == 5 ||
                                cf.questionTypeId == 6 ||
                                cf.questionTypeId == 7
                            ) {
                                enumCustomFields.push(cf);
                            } else if (cf.questionTypeId == 19) {
                                fileCustomFields.push(cf);
                            }
                        });
                        this.sharedService.speakerEnumCustomFields = enumCustomFields;
                        this.sharedService.speakerFileCustomFields = fileCustomFields;
                    }
                });
    }

    helperMethodToLoad(resp) {
        this.sharedService.account = resp.body["accountDTO"];
        this.eventService.getEventByUUID(this.sharedService.eventUUID).subscribe((resp) => {
            this.sharedService.event = resp.body["eventDTO"];
            this.sharedService.updateCss();
            this.loaded = true;
            if(window.location.href.includes("admin")) {
                this.gainsightService.loadScript();
            }
            this.messageService.sendMessage("update-context", {
                account: this.sharedService.account,
                event: this.sharedService.event,
                catalog: this.sharedService.setup
            });
        });
        this.messageService.sendMessage("update-publish-button", {});
    }

    initializeCatalogConfigHelper(resp) {
        let temp: any = resp.body["sessionCatalogSetupDTO"];
        this.sharedService.catalogLayoutConfig = JSON.parse(temp.layoutConfig);
        if (temp.setupConfigs != null) {
            temp.setupConfigs.forEach((element) => {
                this.sharedService.configs[element.configType] = element;
            });
            temp.setupConfigs = null;
        }
        this.sharedService.setup = temp;

        this.getLoggedInAttendee();
    }

    getLoggedInAttendee() {
		// let attendeeIdCookie = this.cookieService.get("attendeeId_" + this.sharedService.setup.id);
	 	let attendeeUUIDCookie = this.cookieService.get("attendeeUUID_" + this.sharedService.setup.id);
	 	if (!this.sharedService.isEmptyString(attendeeUUIDCookie)) {
	 		this.attendeeSessionService.getRegistrationByUUID(attendeeUUIDCookie).subscribe((resp) => {
                let reg = resp.body["registrationDTO"];
                if (reg.id != null && reg.eventId == this.sharedService.event.id) {
                    this.sharedService.loggedInAttendee = resp.body["registrationDTO"];
                    sessionStorage.setItem(
                        "loggedInAttendee_" + this.sharedService.eventUUID,
                        JSON.stringify(this.sharedService.loggedInAttendee)
                    );
                    this.attendeeSessionService.getSessionApiOnLogin();
                    this.popupService.hidePopup();
                }
            });
        }
    }
}
